import InputWrapper from "../InputWrapper/InputWrapper";

export default function TextArea({
  id,
  label,
  attributes,
  register,
  formState,
  wrapperProps,
}) {
  const { errors } = formState;

  if (!id || !label || !register || !formState) {
    return <p>Could not load this field</p>;
  }

  return (
    <InputWrapper id={id} label={label} formState={formState} {...wrapperProps}>
      <textarea
        id={id}
        name={id}
        className={`textArea`}
        {...attributes}
        {...register(id)}
        aria-invalid={errors[id] ? "true" : "false"}
        aria-describedby={
          wrapperProps?.instructions ? `${id}-instructions` : ""
        }
      />
    </InputWrapper>
  );
}
